import { API_ENDPOINTS } from "@/api/services/profile/apiEndPoint";
import { baseApi } from "@/utils/baseApi";

export const fetchImageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getImage: builder.query({
      query: ({ folderName, fileName }) => {
        return {
          url: API_ENDPOINTS.FETCH_IMAGE.FETCH_IMAGE(folderName, fileName),
          method: "GET",
          responseHandler: async (response) => {
            const contentType = response.headers.get("content-type");

            if (contentType && contentType.includes("application/json")) {
              const json = await response.json();

              return null; // return null so no blob is created
            }

            const blob = await response.blob();
            console.log("🖼️ Blob received:", blob);
            return blob;
          },
        };
      },
      transformResponse: (blob) => {
        if (!blob) return null;
        return URL.createObjectURL(blob);
      },
      providesTags: [{ type: "fetchImage", id: "LIST" }],
    }),
  }),
});

export const { useLazyGetImageQuery } = fetchImageApi;
